// JAZ Sales - batches, global search and employee performance (the Sales Manager's sections), plus the Sales Employee's Wait List.
// Merged into salesTranslations.js. Nothing here is shown to Lead Data Entry or to a Sales Employee except the Wait List strings.
export const batchesTranslations = {
  ar: {
    // ---- navigation ----
    nav_batches: 'الدفعات',
    nav_performance: 'الأداء',

    // ---- the Sales Employee's wait list ----
    bt_wait_list: 'قائمة الانتظار',
    bt_wait_listed_since: 'في قائمة الانتظار منذ {date}',
    bt_toast_wait_listed: 'أُضيف العميل إلى قائمة الانتظار',
    bt_wait_hint: 'قائمة الانتظار: يبقى العميل لك وينتقل إلى نهاية قائمتك.',
    event_lead_wait_listed: 'أُضيف إلى قائمة الانتظار',

    // ---- the batches page ----
    bt_title: 'الدفعات',
    bt_subtitle: 'دفعات البيانات والدفعات الرئيسية ودفعات عمل المبيعات، والبحث الشامل. تظهر لمدير المبيعات فقط.',
    bt_tab_data: 'دفعات البيانات',
    bt_tab_master: 'الدفعات الرئيسية',
    bt_tab_work: 'دفعات عمل المبيعات',
    bt_tab_search: 'بحث شامل',
    bt_ov_open_data: 'دفعة البيانات المفتوحة',
    bt_ov_full: 'دفعات بيانات مكتملة',
    bt_ov_toward_master: 'نحو الدفعة الرئيسية التالية',
    bt_ov_masters: 'دفعات رئيسية',
    bt_ov_work_open: 'دفعات عمل مفتوحة',
    bt_ov_work_closed: 'دفعات عمل مغلقة',
    bt_ov_wait: 'عملاء في قائمة الانتظار',
    bt_ov_none_open: 'لا توجد',
    bt_of: '{n} / {total}',
    bt_batch_n: 'الدفعة رقم {n}',
    bt_master_n: 'الدفعة الرئيسية رقم {n}',
    bt_work_n: 'دفعة العمل رقم {n}',
    bt_status_open: 'مفتوحة',
    bt_status_full: 'مكتملة',
    bt_status_closed: 'مغلقة',
    bt_col_number: 'الرقم',
    bt_col_status: 'الحالة',
    bt_col_leads: 'العملاء المحتملون',
    bt_col_opened: 'فُتحت',
    bt_col_filled: 'اكتملت',
    bt_col_master: 'الدفعة الرئيسية',
    bt_col_formed: 'تكوّنت',
    bt_col_data_batches: 'دفعات البيانات',
    bt_col_employee: 'الموظف',
    bt_col_original: 'الأصلي',
    bt_col_current: 'الحالي',
    bt_col_attempts: 'المحاولات',
    bt_col_split: 'النتائج',
    bt_col_created: 'تاريخ التكوّن',
    bt_col_closed: 'أُغلقت',
    bt_empty_data: 'لا توجد دفعات بيانات بعد. تبدأ الدفعة الأولى مع أول عميل محتمل يُدخله موظف إدخال البيانات.',
    bt_empty_master: 'لا توجد دفعات رئيسية بعد. تتكوّن الدفعة الرئيسية تلقائياً كل 10 دفعات بيانات مكتملة.',
    bt_empty_work: 'لا توجد دفعات عمل بعد. تتكوّن الدفعة عندما ينهي موظف المبيعات العمل على 100 عميل محتمل.',
    bt_filter_status: 'الحالة',
    bt_filter_all: 'الكل',
    bt_filter_employee: 'الموظف',
    bt_open_detail: 'التفاصيل',
    bt_load_error: 'تعذر تحميل البيانات',

    // ---- batch details ----
    bt_entered_by: 'أدخله',
    bt_entered_at: 'وقت الإدخال',
    bt_entrants: 'من أدخل هذه الدفعة',
    bt_lead_count_of: '{n} عميل محتمل',
    bt_col_business: 'النشاط التجاري',
    bt_col_type: 'نوع النشاط',
    bt_col_contact: 'الشخص',
    bt_col_phone: 'الهاتف',
    bt_col_stage: 'المرحلة',
    bt_col_owner: 'المسؤول',
    bt_col_entered_by: 'أدخله',
    bt_col_entered_at: 'وقت الإدخال',
    bt_master_batches_inside: 'دفعات البيانات داخل هذه الدفعة الرئيسية',
    bt_attempts_title: 'محاولات الدفعة',
    bt_attempt_n: 'المحاولة {n}',
    bt_attempt_initial: 'أصلية',
    bt_attempt_reassignment: 'إعادة تعيين',
    bt_started_by: 'بدأها',
    bt_started_at: 'بدأت',
    bt_closed_at: 'أُغلقت',
    bt_leads_history: 'العملاء وسجل نتائجهم',
    bt_no_attempts: 'لا توجد محاولات بعد',
    bt_not_started: 'لم يبدأ العمل عليها: {n}',
    bt_reassign_title: 'إعادة تعيين الدفعة',
    bt_reassign_hint: 'تُسلَّم الدفعة المكتملة إلى موظف مبيعات آخر لمحاولة جديدة على العملاء المحتملين أنفسهم (لا تُنسخ). يبقى العملاء الذين وافقوا كما هم، ويُعاد فتح البقية، ويُحفظ كل سجل المحاولات السابقة.',
    bt_reassign_pick: 'اختر موظف المبيعات',
    bt_reassign_submit: 'إعادة تعيين الدفعة',
    bt_reassign_done: 'تمت إعادة تعيين الدفعة',
    bt_reassign_open_note: 'يمكن إعادة تعيين الدفعة بعد اكتمالها فقط: ما زال بعض عملائها في قائمة الانتظار أو قيد العمل.',
    bt_reassign_none_note: 'لا يمكن إعادة تعيين هذه الدفعة: كل عملائها المحتملين إما وافقوا أو أُرشفوا، فلا يوجد ما يُعاد العمل عليه.',
    err_nothing_to_reassign: 'لا يمكن إعادة تعيين هذه الدفعة: كل عملائها المحتملين إما وافقوا أو أُرشفوا.',
    err_work_batch_open: 'لا يمكن إعادة تعيين الدفعة قبل اكتمالها: ما زال بعض عملائها في قائمة الانتظار أو قيد العمل.',
    err_same_employee: 'الدفعة مع هذا الموظف بالفعل. اختر موظف مبيعات آخر.',
    err_lead_closed: 'لا يمكن وضع عميل محتمل فاز أو خسر في قائمة الانتظار.',
    bt_reassign_confirm: 'ستُسلَّم الدفعة إلى {name}. هل تريد المتابعة؟',

    // ---- statistics ----
    bt_stat_accepted_direct: 'موافقة مباشرة',
    bt_stat_rejected_direct: 'رفض مباشر',
    bt_stat_wait_accepted: 'انتظار ← موافقة',
    bt_stat_wait_rejected: 'انتظار ← رفض',
    bt_stat_wait_pending: 'ما زال في الانتظار',
    bt_stat_released: 'خرج من الانتظار',
    bt_stat_accepted: 'إجمالي الموافقات',
    bt_stat_rejected: 'إجمالي الرفض',
    bt_stat_wait_listed: 'وُضع في الانتظار',
    bt_stat_total: 'العملاء',
    bt_stat_percent_hint: 'النسب من العملاء الذين صدر فيهم قرار نهائي.',

    // ---- lead attempt paths ----
    bt_path_direct_accepted: 'موافقة مباشرة',
    bt_path_direct_rejected: 'رفض مباشر',
    bt_path_wait_accepted: 'انتظار ← موافقة',
    bt_path_wait_rejected: 'انتظار ← رفض',
    bt_path_wait_pending: 'في الانتظار',
    bt_path_released: 'خرج من الانتظار بلا قرار',
    bt_attempt_by: 'بواسطة {name}',
    bt_attempt_at: 'القرار {date}',
    bt_attempt_wait_at: 'وُضع في الانتظار {date}',
    bt_attempt_result_at: 'النتيجة {date}',

    // ---- search ----
    bt_search_label: 'ابحث في كل الدفعات',
    bt_search_placeholder: 'اسم النشاط التجاري أو اسم الشخص أو الهاتف أو نوع النشاط',
    bt_search_field: 'البحث في',
    bt_field_any: 'كل الحقول',
    bt_field_business_name: 'اسم النشاط التجاري',
    bt_field_contact_name: 'اسم الشخص',
    bt_field_phone: 'الهاتف',
    bt_field_business_type: 'نوع النشاط',
    bt_search_submit: 'بحث',
    bt_search_min: 'اكتب حرفين على الأقل',
    bt_search_none: 'لا توجد نتائج',
    bt_search_count: '{shown} من {total} نتيجة',
    bt_search_more: 'اعرض نتائج أقل عدداً بتضييق البحث',
    bt_trace: 'المسار الكامل',
    bt_trace_title: 'مسار العميل المحتمل',
    bt_trace_data_batch: 'دفعة البيانات',
    bt_trace_master_batch: 'الدفعة الرئيسية',
    bt_trace_work_batches: 'دفعات العمل',
    bt_trace_attempts: 'المحاولات والنتائج',
    bt_trace_timeline: 'السجل الزمني',
    bt_trace_none_batch: 'خارج دفعات الإدخال',
    bt_trace_none_master: 'لم تكتمل بعد',
    bt_trace_none_work: 'لم يدخل دفعة عمل بعد',

    // ---- performance ----
    pf_title: 'أداء الموظفين',
    pf_subtitle: 'إحصاءات موظفي إدخال البيانات والمبيعات وساعات عملهم. تظهر لمدير المبيعات فقط.',
    pf_tab_data_entry: 'إدخال البيانات',
    pf_tab_sales: 'المبيعات',
    pf_period: 'الفترة',
    pf_period_today: 'اليوم',
    pf_period_month: 'هذا الشهر',
    pf_period_year: 'هذه السنة',
    pf_period_lifetime: 'منذ البداية',
    pf_col_employee: 'الموظف',
    pf_col_entered: 'عملاء أُدخلوا',
    pf_col_hours: 'ساعات العمل',
    pf_col_worked: 'عملاء تم العمل عليهم',
    pf_col_accepted: 'موافقات',
    pf_col_rejected: 'رفض',
    pf_col_accepted_pct: 'نسبة الموافقة',
    pf_col_rejected_pct: 'نسبة الرفض',
    pf_col_wait: 'وُضعوا في الانتظار',
    pf_col_wait_pending: 'ما زالوا في الانتظار',
    pf_col_wait_accepted: 'انتظار ← موافقة',
    pf_col_wait_rejected: 'انتظار ← رفض',
    pf_col_batches: 'دفعات مكتملة',
    pf_empty_data_entry: 'لا يوجد موظفو إدخال بيانات',
    pf_empty_sales: 'لا يوجد موظفو مبيعات',
    pf_inactive: 'غير نشط',
    pf_open_detail: 'التفاصيل والسجل',
    pf_hours_value: '{h} س',
    pf_detail_periods: 'الفترات',
    pf_detail_history: 'السجل اليومي (محفوظ بشكل دائم)',
    pf_detail_sessions: 'آخر جلسات العمل',
    pf_history_days: 'آخر {n} يوماً',
    pf_col_date: 'اليوم',
    pf_col_session_start: 'البداية',
    pf_col_session_end: 'النهاية',
    pf_col_session_minutes: 'الدقائق',
    pf_col_session_actions: 'الإجراءات',
    pf_no_history: 'لا يوجد عمل مسجّل في هذه الفترة',
    pf_hours_hint: 'ساعات العمل مأخوذة من الإجراءات المسجّلة: الإجراءات المتقاربة (أقل من 15 دقيقة بينها) تُعدّ جلسة واحدة.',
    pf_search: 'ابحث باسم الموظف',
  },
  en: {
    nav_batches: 'Batches',
    nav_performance: 'Performance',

    bt_wait_list: 'Wait List',
    bt_wait_listed_since: 'On the wait list since {date}',
    bt_toast_wait_listed: 'Lead added to the wait list',
    bt_wait_hint: 'Wait List: the lead stays yours and moves to the end of your queue.',
    event_lead_wait_listed: 'Added to the wait list',

    bt_title: 'Batches',
    bt_subtitle: 'Data batches, master batches, Sales work batches and the global search. Visible to the Sales Manager only.',
    bt_tab_data: 'Data batches',
    bt_tab_master: 'Master batches',
    bt_tab_work: 'Sales work batches',
    bt_tab_search: 'Global search',
    bt_ov_open_data: 'Open data batch',
    bt_ov_full: 'Full data batches',
    bt_ov_toward_master: 'Toward the next master batch',
    bt_ov_masters: 'Master batches',
    bt_ov_work_open: 'Open work batches',
    bt_ov_work_closed: 'Closed work batches',
    bt_ov_wait: 'Leads on the wait list',
    bt_ov_none_open: 'None',
    bt_of: '{n} / {total}',
    bt_batch_n: 'Batch #{n}',
    bt_master_n: 'Master batch #{n}',
    bt_work_n: 'Work batch #{n}',
    bt_status_open: 'Open',
    bt_status_full: 'Full',
    bt_status_closed: 'Closed',
    bt_col_number: 'Number',
    bt_col_status: 'Status',
    bt_col_leads: 'Leads',
    bt_col_opened: 'Opened',
    bt_col_filled: 'Filled',
    bt_col_master: 'Master batch',
    bt_col_formed: 'Formed',
    bt_col_data_batches: 'Data batches',
    bt_col_employee: 'Employee',
    bt_col_original: 'Original',
    bt_col_current: 'Current',
    bt_col_attempts: 'Attempts',
    bt_col_split: 'Results',
    bt_col_created: 'Formed',
    bt_col_closed: 'Closed',
    bt_empty_data: 'No data batches yet. The first one starts with the first lead a Data Entry employee enters.',
    bt_empty_master: 'No master batches yet. One forms automatically for every 10 full data batches.',
    bt_empty_work: 'No work batches yet. One forms when a Sales Employee has worked 100 leads.',
    bt_filter_status: 'Status',
    bt_filter_all: 'All',
    bt_filter_employee: 'Employee',
    bt_open_detail: 'Details',
    bt_load_error: 'Could not load the data',

    bt_entered_by: 'Entered by',
    bt_entered_at: 'Entered at',
    bt_entrants: 'Who entered this batch',
    bt_lead_count_of: '{n} leads',
    bt_col_business: 'Business',
    bt_col_type: 'Activity type',
    bt_col_contact: 'Person',
    bt_col_phone: 'Phone',
    bt_col_stage: 'Stage',
    bt_col_owner: 'Owner',
    bt_col_entered_by: 'Entered by',
    bt_col_entered_at: 'Entered at',
    bt_master_batches_inside: 'Data batches inside this master batch',
    bt_attempts_title: 'Batch attempts',
    bt_attempt_n: 'Attempt {n}',
    bt_attempt_initial: 'Original',
    bt_attempt_reassignment: 'Reassignment',
    bt_started_by: 'Started by',
    bt_started_at: 'Started',
    bt_closed_at: 'Closed',
    bt_leads_history: 'Leads and their result history',
    bt_no_attempts: 'No attempts yet',
    bt_not_started: 'Not started: {n}',
    bt_reassign_title: 'Reassign this batch',
    bt_reassign_hint: 'A completed batch goes to another Sales Employee for a new attempt at the same leads (never copies). Leads that already agreed stay as they are, the rest are reopened, and every earlier attempt stays on record.',
    bt_reassign_pick: 'Choose the Sales Employee',
    bt_reassign_submit: 'Reassign batch',
    bt_reassign_done: 'Batch reassigned',
    bt_reassign_open_note: 'A batch can be reassigned once it is completed: some of its leads are still on the wait list or being worked.',
    bt_reassign_none_note: 'This batch cannot be reassigned: every one of its leads has already agreed or been archived, so there is nothing left to work.',
    err_nothing_to_reassign: 'This batch cannot be reassigned: every one of its leads has already agreed or been archived.',
    err_work_batch_open: 'A batch cannot be reassigned before it is completed: some of its leads are still on the wait list or being worked.',
    err_same_employee: 'The batch is already with this person. Choose another Sales Employee.',
    err_lead_closed: 'A won or lost lead cannot go on the wait list.',
    bt_reassign_confirm: 'The batch will go to {name}. Continue?',

    bt_stat_accepted_direct: 'Accepted directly',
    bt_stat_rejected_direct: 'Rejected directly',
    bt_stat_wait_accepted: 'Wait List → Accepted',
    bt_stat_wait_rejected: 'Wait List → Rejected',
    bt_stat_wait_pending: 'Still waiting',
    bt_stat_released: 'Left the wait list',
    bt_stat_accepted: 'Total accepted',
    bt_stat_rejected: 'Total rejected',
    bt_stat_wait_listed: 'Put on the wait list',
    bt_stat_total: 'Leads',
    bt_stat_percent_hint: 'Percentages are of the leads with a final result.',

    bt_path_direct_accepted: 'Accepted directly',
    bt_path_direct_rejected: 'Rejected directly',
    bt_path_wait_accepted: 'Wait List → Accepted',
    bt_path_wait_rejected: 'Wait List → Rejected',
    bt_path_wait_pending: 'On the wait list',
    bt_path_released: 'Left the wait list with no decision',
    bt_attempt_by: 'by {name}',
    bt_attempt_at: 'Decided {date}',
    bt_attempt_wait_at: 'Wait-listed {date}',
    bt_attempt_result_at: 'Result {date}',

    bt_search_label: 'Search every batch',
    bt_search_placeholder: 'Business name, person name, phone or activity type',
    bt_search_field: 'Search in',
    bt_field_any: 'All fields',
    bt_field_business_name: 'Business name',
    bt_field_contact_name: 'Person name',
    bt_field_phone: 'Phone',
    bt_field_business_type: 'Activity type',
    bt_search_submit: 'Search',
    bt_search_min: 'Type at least 2 characters',
    bt_search_none: 'No results',
    bt_search_count: '{shown} of {total} results',
    bt_search_more: 'Narrow the search to see fewer, more specific results',
    bt_trace: 'Full trace',
    bt_trace_title: 'Lead trace',
    bt_trace_data_batch: 'Data batch',
    bt_trace_master_batch: 'Master batch',
    bt_trace_work_batches: 'Work batches',
    bt_trace_attempts: 'Attempts and results',
    bt_trace_timeline: 'Timeline',
    bt_trace_none_batch: 'Not in a data batch',
    bt_trace_none_master: 'Not formed yet',
    bt_trace_none_work: 'Not in a work batch yet',

    pf_title: 'Employee performance',
    pf_subtitle: 'Statistics and work hours of Data Entry and Sales employees. Visible to the Sales Manager only.',
    pf_tab_data_entry: 'Data Entry',
    pf_tab_sales: 'Sales',
    pf_period: 'Period',
    pf_period_today: 'Today',
    pf_period_month: 'This month',
    pf_period_year: 'This year',
    pf_period_lifetime: 'Lifetime',
    pf_col_employee: 'Employee',
    pf_col_entered: 'Leads entered',
    pf_col_hours: 'Work hours',
    pf_col_worked: 'Leads worked',
    pf_col_accepted: 'Accepted',
    pf_col_rejected: 'Rejected',
    pf_col_accepted_pct: 'Accepted %',
    pf_col_rejected_pct: 'Rejected %',
    pf_col_wait: 'Wait-listed',
    pf_col_wait_pending: 'Still waiting',
    pf_col_wait_accepted: 'Wait → Accepted',
    pf_col_wait_rejected: 'Wait → Rejected',
    pf_col_batches: 'Completed batches',
    pf_empty_data_entry: 'No Data Entry employees',
    pf_empty_sales: 'No Sales employees',
    pf_inactive: 'Inactive',
    pf_open_detail: 'Details and history',
    pf_hours_value: '{h} h',
    pf_detail_periods: 'Periods',
    pf_detail_history: 'Daily history (kept permanently)',
    pf_detail_sessions: 'Latest work sessions',
    pf_history_days: 'Last {n} days',
    pf_col_date: 'Day',
    pf_col_session_start: 'Start',
    pf_col_session_end: 'End',
    pf_col_session_minutes: 'Minutes',
    pf_col_session_actions: 'Actions',
    pf_no_history: 'No recorded work in this range',
    pf_hours_hint: 'Work hours come from recorded actions: actions less than 15 minutes apart count as one session.',
    pf_search: 'Search by employee name',
  },
};
